export default __webpack_public_path__ + "static/media/nl.1ea06a36.svg";